import blocks from './blocks';
import components from './components';

export default (editor, config, currentMode) => {
  blocks(editor, config, currentMode);
  components(editor, config);
};
